import { render, staticRenderFns } from "./homeIcon.vue?vue&type=template&id=b9d6be4a&scoped=true&"
import script from "./homeIcon.vue?vue&type=script&lang=js&"
export * from "./homeIcon.vue?vue&type=script&lang=js&"
import style0 from "./homeIcon.vue?vue&type=style&index=0&id=b9d6be4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d6be4a",
  null
  
)

export default component.exports